
const digest = '0577e9a1ad848df064ae1b5e637b1be49d376763a4876b01ca1e237399c40daf';
const classes = {"wrapper":"_wrapper_1svoe_1","backdrop":"_backdrop_1svoe_1","sidebar":"_sidebar_1svoe_10","header":"_header_1svoe_21","title":"_title_1svoe_29","closeButton":"_closeButton_1svoe_34","body":"_body_1svoe_37","content":"_content_1svoe_40"};
const css = `._wrapper_1svoe_1 ._backdrop_1svoe_1 {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
._wrapper_1svoe_1 ._sidebar_1svoe_10 {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 415px;
  background-color: #fff;
  z-index: 99999;
  display: flex;
  flex-direction: column;
}
._wrapper_1svoe_1 ._sidebar_1svoe_10 ._header_1svoe_21 {
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 19px;
  justify-content: space-between;
  border-bottom: 1px solid #1d65d8;
}
._wrapper_1svoe_1 ._sidebar_1svoe_10 ._header_1svoe_21 ._title_1svoe_29 {
  font-weight: 500;
  font-size: 16px;
  color: #1d65d8;
}
._wrapper_1svoe_1 ._sidebar_1svoe_10 ._header_1svoe_21 ._closeButton_1svoe_34 {
  cursor: pointer;
}
._wrapper_1svoe_1 ._sidebar_1svoe_10 ._body_1svoe_37 {
  flex: 1;
}
._wrapper_1svoe_1 ._sidebar_1svoe_10 ._body_1svoe_37 ._content_1svoe_40 {
  height: calc(100vh - 100px);
  overflow: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  